export default __webpack_public_path__ + "static/media/monitorwise-mark.747126cf.svg";